import { useEffect, useRef } from "react";

const PALETTE = ["#2f2e29", "#c9971f", "#e3bb52"];
const STATIC = { dark: "#2f2e29", gold: "#c9971f", light: "#e3bb52" };
// Canale blu alto = particelle del gruppo "inserto in movimento": serve solo al campionamento.
const MOVING = { dark: "rgb(47,46,255)", gold: "rgb(201,151,255)", light: "rgb(227,187,255)" };
const MONO = "'IBM Plex Mono', 'Courier New', monospace";

/* 0 · Flusso sconnesso: frammenti che vanno ognuno per conto proprio. */
function drawScatter(g, cx) {
  g.lineCap = "round";
  const colors = [STATIC.gold, STATIC.dark, STATIC.light];
  for (let i = 0; i < 26; i++) {
    const y = 46 + i * 36;
    const x = cx - 160 + ((i * 97) % 250);
    g.strokeStyle = colors[i % 3];
    g.lineWidth = 8 - (i % 3) * 2;
    g.beginPath();
    g.moveTo(x, y);
    g.bezierCurveTo(x + 54, y - 30, x + 96, y + 34, x + 132 - (i % 5) * 24, y + 10);
    g.stroke();
  }
  for (let i = 0; i < 46; i++) {
    g.fillStyle = colors[(i * 2) % 3];
    const x = cx - 196 + ((i * 137) % 392);
    const y = 26 + ((i * 211) % 948);
    g.beginPath();
    g.arc(x, y, 4 + (i % 3), 0, Math.PI * 2);
    g.fill();
  }
}

/* 1 · Amministrazione e controllo: i dati diventano un diagramma a barre. */
function drawBarChart(g, cx) {
  const left = cx - 176;
  const right = cx + 176;
  const base = 800;
  g.textAlign = "center";
  g.textBaseline = "middle";
  g.fillStyle = STATIC.gold;
  g.font = `bold 52px ${MONO}`;
  g.fillText("ORE · € · %", cx, 132);
  g.strokeStyle = STATIC.light;
  g.lineWidth = 3;
  g.setLineDash([14, 20]);
  for (let k = 1; k <= 4; k++) {
    const y = base - k * 128;
    g.beginPath();
    g.moveTo(left, y);
    g.lineTo(right, y);
    g.stroke();
  }
  g.setLineDash([]);
  const heights = [196, 322, 268, 452, 386, 528];
  heights.forEach((h, i) => {
    const x = left + 26 + i * 56;
    g.strokeStyle = STATIC.dark;
    g.lineWidth = 6;
    g.strokeRect(x, base - h, 40, h);
    g.fillStyle = i % 2 ? STATIC.gold : STATIC.light;
    g.fillRect(x + 6, base - h + 6, 28, 26);
  });
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 9;
  g.beginPath();
  g.moveTo(left, 196);
  g.lineTo(left, base);
  g.lineTo(right, base);
  g.stroke();
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 7;
  g.lineJoin = "round";
  g.beginPath();
  heights.forEach((h, i) => {
    const x = left + 46 + i * 56;
    const y = base - h - 46;
    if (i) g.lineTo(x, y); else g.moveTo(x, y);
  });
  g.stroke();
  heights.forEach((h, i) => {
    g.fillStyle = STATIC.dark;
    g.beginPath();
    g.arc(left + 46 + i * 56, base - h - 46, 9, 0, Math.PI * 2);
    g.fill();
  });
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 7;
  g.strokeRect(cx - 168, base + 96, 336, 116);
  g.fillStyle = STATIC.dark;
  g.font = `bold 70px ${MONO}`;
  g.fillText("+18,4 %", cx, base + 154);
}

function insertPath(g, x, y, s) {
  g.beginPath();
  g.moveTo(x, y - 320 * s);
  g.quadraticCurveTo(x + 40 * s, y - 250 * s, x + 152 * s, y - 30 * s);
  g.quadraticCurveTo(x + 168 * s, y, x + 152 * s, y + 30 * s);
  g.quadraticCurveTo(x + 40 * s, y + 250 * s, x, y + 320 * s);
  g.quadraticCurveTo(x - 40 * s, y + 250 * s, x - 152 * s, y + 30 * s);
  g.quadraticCurveTo(x - 168 * s, y, x - 152 * s, y - 30 * s);
  g.quadraticCurveTo(x - 40 * s, y - 250 * s, x, y - 320 * s);
  g.closePath();
}

function drawInsertAt(g, x, y, s, colors) {
  g.fillStyle = colors.gold;
  insertPath(g, x, y, s);
  g.fill();
  g.strokeStyle = colors.dark;
  g.lineWidth = 14 * s;
  insertPath(g, x, y, s);
  g.stroke();
  g.strokeStyle = colors.light;
  g.lineWidth = 9 * s;
  insertPath(g, x, y, 0.72 * s);
  g.stroke();
  insertPath(g, x, y, 0.45 * s);
  g.stroke();
  g.globalCompositeOperation = "destination-out";
  g.beginPath();
  g.arc(x, y, 58 * s, 0, Math.PI * 2);
  g.fill();
  g.globalCompositeOperation = "source-over";
  g.strokeStyle = colors.dark;
  g.lineWidth = 12 * s;
  g.beginPath();
  g.arc(x, y, 62 * s, 0, Math.PI * 2);
  g.stroke();
}

/* 2 · Logistica utensili: l'inserto di tornitura. */
function drawInsert(g, cx) {
  drawInsertAt(g, cx, 500, 1, STATIC);
}

/* 3 · Acquisti e fornitori: l'ordine confermato e le barre che arrivano sul pallet. */
function drawSupplyOrder(g, cx) {
  g.textAlign = "center";
  g.textBaseline = "middle";
  g.fillStyle = STATIC.gold;
  g.font = `bold 32px ${MONO}`;
  g.fillText("ORDINE FORNITORE", cx, 74);
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 8;
  g.strokeRect(cx - 194, 118, 388, 296);
  const rows = [
    ["BARRA Ø45", "6 pz"],
    ["INSERTI CNMG", "40 pz"],
    ["FRESA Ø12 R1", "4 pz"],
  ];
  rows.forEach(([label, qty], index) => {
    const y = 182 + index * 78;
    g.fillStyle = index % 2 ? STATIC.light : STATIC.gold;
    g.fillRect(cx - 168, y - 16, 32, 32);
    g.textAlign = "left";
    g.fillStyle = STATIC.dark;
    g.font = `bold 28px ${MONO}`;
    g.fillText(label, cx - 122, y);
    g.textAlign = "right";
    g.fillStyle = STATIC.gold;
    g.fillText(qty, cx + 168, y);
    g.strokeStyle = STATIC.light;
    g.lineWidth = 3;
    g.beginPath();
    g.moveTo(cx - 168, y + 30);
    g.lineTo(cx + 168, y + 30);
    g.stroke();
  });
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 6;
  g.strokeRect(cx - 148, 430, 296, 64);
  g.textAlign = "center";
  g.fillStyle = STATIC.dark;
  g.font = `bold 30px ${MONO}`;
  g.fillText("CONFERMATO", cx, 462);
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 10;
  g.beginPath();
  g.moveTo(cx, 520);
  g.lineTo(cx, 592);
  g.stroke();
  g.fillStyle = STATIC.dark;
  g.beginPath();
  g.moveTo(cx, 638);
  g.lineTo(cx - 30, 584);
  g.lineTo(cx + 30, 584);
  g.closePath();
  g.fill();
  for (let i = 0; i < 3; i++) {
    const y = 686 + i * 62;
    g.strokeStyle = i === 1 ? STATIC.gold : STATIC.dark;
    g.lineWidth = 9;
    g.beginPath();
    g.moveTo(cx - 152, y);
    g.lineTo(cx + 152, y);
    g.moveTo(cx - 152, y + 34);
    g.lineTo(cx + 152, y + 34);
    g.stroke();
    g.strokeStyle = STATIC.light;
    g.lineWidth = 7;
    g.beginPath();
    g.ellipse(cx + 152, y + 17, 13, 17, 0, 0, Math.PI * 2);
    g.stroke();
  }
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 10;
  g.beginPath();
  g.moveTo(cx - 180, 888);
  g.lineTo(cx + 180, 888);
  g.moveTo(cx - 180, 922);
  g.lineTo(cx + 180, 922);
  g.stroke();
  for (let i = 0; i < 4; i++) {
    const x = cx - 180 + i * 120;
    g.beginPath();
    g.moveTo(x, 888);
    g.lineTo(x, 922);
    g.stroke();
  }
}

const BAR = { hw: 74, top: 150, bottom: 944 };

function drawBar(g, cx) {
  const bx = cx - 58;
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 11;
  g.strokeRect(bx - BAR.hw - 38, 58, (BAR.hw + 38) * 2, 80);
  g.fillStyle = STATIC.gold;
  for (let i = 0; i < 3; i++) g.fillRect(bx - BAR.hw - 14 + i * 72, 74, 30, 48);
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 12;
  g.beginPath();
  g.moveTo(bx - BAR.hw, BAR.top);
  g.lineTo(bx - BAR.hw, BAR.bottom);
  g.moveTo(bx + BAR.hw, BAR.top);
  g.lineTo(bx + BAR.hw, BAR.bottom);
  g.stroke();
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 8;
  g.beginPath();
  g.moveTo(bx - 26, BAR.top);
  g.lineTo(bx - 26, BAR.bottom);
  g.stroke();
  g.strokeStyle = STATIC.light;
  g.lineWidth = 5;
  g.beginPath();
  g.moveTo(bx + 30, BAR.top);
  g.lineTo(bx + 30, BAR.bottom);
  g.stroke();
  g.strokeStyle = STATIC.light;
  g.lineWidth = 9;
  g.beginPath();
  g.ellipse(bx, BAR.top, BAR.hw, 26, 0, 0, Math.PI * 2);
  g.stroke();
  g.beginPath();
  g.ellipse(bx, BAR.bottom, BAR.hw, 26, 0, 0, Math.PI * 2);
  g.stroke();
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 6;
  g.beginPath();
  g.ellipse(bx, BAR.top, BAR.hw * 0.48, 13, 0, 0, Math.PI * 2);
  g.stroke();
  return bx;
}

/* 3 · Produzione: l'inserto avanza lungo la barra cilindrica. */
function drawBarWithInsert(g, cx) {
  const bx = drawBar(g, cx);
  g.strokeStyle = STATIC.light;
  g.lineWidth = 7;
  g.lineCap = "round";
  for (let i = 0; i < 3; i++) {
    const y = 470 + i * 26;
    g.beginPath();
    g.moveTo(bx + BAR.hw - 6, y);
    g.bezierCurveTo(bx + BAR.hw + 40, y - 34, bx + BAR.hw + 64, y + 28, bx + BAR.hw + 22, y + 44);
    g.stroke();
  }
  drawInsertAt(g, cx + 148, 520, 0.36, MOVING);
  g.fillStyle = MOVING.dark;
  g.fillRect(cx + 178, 484, 58, 72);
}

function dimensionArrow(g, x, y, dx) {
  g.beginPath();
  g.moveTo(x, y);
  g.lineTo(x + dx, y - 13);
  g.lineTo(x + dx, y + 13);
  g.closePath();
  g.fill();
}

/* 4 · Qualità: l'inserto ha finito la passata, sulla barra restano quote e tolleranze. */
function drawQuotedBar(g, cx) {
  const bx = drawBar(g, cx);
  drawInsertAt(g, cx + 150, 916, 0.3, MOVING);
  g.textAlign = "center";
  g.textBaseline = "middle";
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 7;
  g.beginPath();
  g.moveTo(bx - BAR.hw, 300);
  g.lineTo(bx + BAR.hw, 300);
  g.stroke();
  g.fillStyle = STATIC.gold;
  dimensionArrow(g, bx - BAR.hw, 300, 32);
  dimensionArrow(g, bx + BAR.hw, 300, -32);
  g.font = `bold 62px ${MONO}`;
  g.fillText("Ø42 h7", bx + 20, 238);
  g.strokeStyle = STATIC.light;
  g.lineWidth = 6;
  g.beginPath();
  g.moveTo(cx + 128, 392);
  g.lineTo(cx + 128, 716);
  g.stroke();
  g.fillStyle = STATIC.light;
  g.beginPath();
  g.moveTo(cx + 128, 392);
  g.lineTo(cx + 112, 428);
  g.lineTo(cx + 144, 428);
  g.closePath();
  g.fill();
  g.beginPath();
  g.moveTo(cx + 128, 716);
  g.lineTo(cx + 112, 680);
  g.lineTo(cx + 144, 680);
  g.closePath();
  g.fill();
  g.save();
  g.translate(cx + 186, 554);
  g.rotate(Math.PI / 2);
  g.fillStyle = STATIC.light;
  g.font = `bold 54px ${MONO}`;
  g.fillText("±0,05", 0, 0);
  g.restore();
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 7;
  g.strokeRect(cx - 200, 452, 344, 96);
  g.beginPath();
  g.moveTo(cx - 108, 452);
  g.lineTo(cx - 108, 548);
  g.moveTo(cx + 42, 452);
  g.lineTo(cx + 42, 548);
  g.stroke();
  g.fillStyle = STATIC.dark;
  g.font = `bold 54px ${MONO}`;
  g.fillText("//", cx - 154, 500);
  g.fillText("0,02", cx - 33, 500);
  g.fillText("A", cx + 93, 500);
  g.strokeStyle = STATIC.dark;
  g.lineWidth = 7;
  g.strokeRect(cx - 200, 660, 104, 92);
  g.fillStyle = STATIC.dark;
  g.font = `bold 58px ${MONO}`;
  g.fillText("A", cx - 148, 706);
  g.beginPath();
  g.moveTo(cx - 148, 752);
  g.lineTo(cx - 178, 806);
  g.lineTo(cx - 118, 806);
  g.closePath();
  g.fill();
}

/* 5 · Preventivazione: quote e passate diventano lavorazioni con tempi e costi. */
function drawCostSheet(g, cx) {
  g.textBaseline = "middle";
  g.textAlign = "center";
  g.fillStyle = STATIC.gold;
  g.font = `bold 34px ${MONO}`;
  g.fillText("PREVENTIVO", cx, 112);
  g.fillStyle = STATIC.dark;
  g.font = `bold 46px ${MONO}`;
  g.fillText("TEMPI E COSTI", cx, 180);
  const rows = [
    ["SBOZZ 8,4'", "22,60 €"],
    ["FINIT 6,1'", "16,40 €"],
    ["FORAT 3,2'", "8,60 €"],
    ["CONTR 2,0'", "5,20 €"],
  ];
  rows.forEach(([label, cost], index) => {
    const y = 300 + index * 96;
    g.fillStyle = index % 2 ? STATIC.light : STATIC.gold;
    g.fillRect(cx - 202, y - 18, 34, 34);
    g.textAlign = "left";
    g.fillStyle = STATIC.dark;
    g.font = `bold 34px ${MONO}`;
    g.fillText(label, cx - 152, y);
    g.textAlign = "right";
    g.fillStyle = STATIC.gold;
    g.fillText(cost, cx + 202, y);
    g.strokeStyle = STATIC.light;
    g.lineWidth = 3;
    g.beginPath();
    g.moveTo(cx - 202, y + 42);
    g.lineTo(cx + 202, y + 42);
    g.stroke();
  });
  g.strokeStyle = STATIC.gold;
  g.lineWidth = 8;
  g.strokeRect(cx - 202, 706, 404, 132);
  g.textAlign = "left";
  g.fillStyle = STATIC.dark;
  g.font = `bold 32px ${MONO}`;
  g.fillText("TOTALE", cx - 178, 744);
  g.fillStyle = STATIC.gold;
  g.font = `bold 62px ${MONO}`;
  g.fillText("52,80 €", cx - 178, 800);
  const bars = [
    ["MATERIALE", 118],
    ["MACCHINA", 232],
    ["UTENSILI", 78],
  ];
  bars.forEach(([label, width], index) => {
    const y = 884 + index * 40;
    g.fillStyle = index === 1 ? STATIC.gold : STATIC.light;
    g.fillRect(cx - 202, y, width, 24);
    g.fillStyle = STATIC.dark;
    g.font = `bold 24px ${MONO}`;
    g.fillText(label, cx - 194 + width + 14, y + 12);
  });
}

const SHAPES = [drawScatter, drawBarChart, drawInsert, drawSupplyOrder, drawBarWithInsert, drawQuotedBar, drawCostSheet];
const MOVING_SHAPE = 4;

function samplePoints(draw) {
  const off = document.createElement("canvas");
  off.width = 440;
  off.height = 1000;
  const g = off.getContext("2d");
  draw(g, 220);
  const data = g.getImageData(0, 0, 440, 1000).data;
  const points = [];
  for (let y = 0; y < 1000; y += 3) {
    for (let x = 0; x < 440; x += 3) {
      const i = (y * 440 + x) * 4;
      if (data[i + 3] > 90) {
        const r = data[i];
        points.push({ nx: x / 440, ny: y / 1000, k: r < 100 ? 0 : r >= 215 ? 2 : 1, g: data[i + 2] > 200 ? 1 : 0 });
      }
    }
  }
  for (let i = points.length - 1; i > 0; i--) {
    const j = (Math.random() * (i + 1)) | 0;
    [points[i], points[j]] = [points[j], points[i]];
  }
  return points;
}

const ease = (t) => t * t * (3 - 2 * t);
const clamp = (v, a, b) => Math.min(Math.max(v, a), b);

export function ParticleCanvas({ progressRef }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const shapePoints = SHAPES.map(samplePoints);
    const COUNT = window.innerWidth < 760 ? 2100 : 5200;
    const rand = (a, b) => a + Math.random() * (b - a);
    const particles = [];
    for (let i = 0; i < COUNT; i++) {
      particles.push({
        targets: shapePoints.map((pts) => pts[i % pts.length]),
        stag: Math.random(),
        sx: Math.random(), sy: Math.random(),
        dr: rand(0, Math.PI * 2), ds: rand(0.15, 0.9),
        puff: rand(0.4, 1.6),
        ox: 0, oy: 0, vx: 0, vy: 0,
        size: rand(1.2, 2.5), alpha: rand(0.55, 1),
      });
    }
    let W = 0, H = 0, raf = 0, P = 0;
    let mouseX = -9999, mouseY = -9999;
    const layout = () => {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    const onMove = (event) => { mouseX = event.clientX; mouseY = event.clientY; };
    const onTouch = (event) => { if (event.touches[0]) { mouseX = event.touches[0].clientX; mouseY = event.touches[0].clientY; } };
    const onLeave = () => { mouseX = -9999; mouseY = -9999; };
    const onDown = (event) => {
      const bx = event.clientX, by = event.clientY;
      for (const p of particles) {
        const dx = p.lx - bx, dy = p.ly - by;
        const d2 = dx * dx + dy * dy;
        if (d2 < 48400 && d2 > 0.01) {
          const d = Math.sqrt(d2);
          const f = (1 - d / 220) * 24;
          p.vx += (dx / d) * f; p.vy += (dy / d) * f;
        }
      }
    };
    layout();
    window.addEventListener("resize", layout);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove", onTouch, { passive: true });
    window.addEventListener("mouseout", onLeave);
    window.addEventListener("pointerdown", onDown);

    const SEG = SHAPES.length;
    const frame = (tms) => {
      const t = tms / 1000;
      const target = clamp(progressRef.current || 0, 0, 1);
      P += (target - P) * (reduced ? 1 : 0.075);
      ctx.clearRect(0, 0, W, H);
      const isMobile = W < 900;
      const toolH = H * (isMobile ? 0.6 : 0.78);
      const toolW = toolH * 0.44;
      const parallax = mouseX > -9000 ? (mouseX / W - 0.5) * 26 : 0;
      const cx = (isMobile ? W * 0.5 : W * 0.66) + parallax;
      const topY = H * (isMobile ? 0.21 : 0.11);
      const f = P * SEG;
      const seg = Math.min(Math.floor(f), SEG - 1);
      const st = clamp(f - seg, 0, 1);
      // La passata: nel modulo Produzione l'inserto scorre lungo la barra.
      const travel = seg === MOVING_SHAPE ? (((t * 0.11) % 1) - 0.5) * 0.62 : 0;
      for (const p of particles) {
        let x, y, k, vis;
        if (seg === 0) {
          const local = ease(clamp((st - p.stag * 0.5) / 0.5, 0, 1));
          const dust = 1 - local;
          const a = p.targets[0];
          const dx = p.sx * W + Math.sin(t * p.ds + p.dr) * 48 * dust;
          const dy = p.sy * H + Math.cos(t * p.ds * 0.8 + p.dr) * 36 * dust;
          const hx = cx + (a.nx - 0.5) * toolW;
          const hy = topY + a.ny * toolH;
          x = dx + (hx - dx) * local;
          y = dy + (hy - dy) * local;
          k = a.k; vis = 0.3 + 0.7 * local;
        } else {
          const mm = ease(clamp((st - p.stag * 0.3) / 0.7, 0, 1));
          const a = p.targets[seg - 1], b = p.targets[seg];
          const puff = Math.sin(Math.PI * mm) * 30 * p.puff;
          x = cx + ((a.nx + (b.nx - a.nx) * mm) - 0.5) * toolW + Math.cos(p.dr) * puff;
          y = topY + (a.ny + (b.ny - a.ny) * mm) * toolH + Math.sin(p.dr) * puff;
          if (travel && b.g === 1) y += travel * toolH * mm;
          k = mm < 0.5 ? a.k : b.k; vis = 1;
        }
        x += Math.sin(t * 1.4 + p.dr) * 0.7;
        y += Math.cos(t * 1.1 + p.dr) * 0.5;
        const mdx = x - mouseX, mdy = y - mouseY;
        const d2 = mdx * mdx + mdy * mdy;
        if (d2 < 12100 && d2 > 0.01) {
          const d = Math.sqrt(d2);
          const push = (1 - d / 110) * 2.8;
          p.vx += (mdx / d) * push; p.vy += (mdy / d) * push;
        }
        p.vx += -p.ox * 0.06; p.vy += -p.oy * 0.06;
        p.vx *= 0.87; p.vy *= 0.87;
        p.ox += p.vx; p.oy += p.vy;
        x += p.ox; y += p.oy;
        p.lx = x; p.ly = y;
        ctx.globalAlpha = p.alpha * vis;
        ctx.fillStyle = PALETTE[k];
        ctx.fillRect(x, y, p.size, p.size);
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    };
    raf = requestAnimationFrame(frame);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", layout);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove", onTouch);
      window.removeEventListener("mouseout", onLeave);
      window.removeEventListener("pointerdown", onDown);
    };
  }, [progressRef]);

  return <canvas ref={canvasRef} className="landing-canvas" data-testid="landing-particle-canvas" />;
}
